import React from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { visibilityIcon } from '@/constants/images';
import { datasetAdminUrl } from '@/constants/urls';

const DatasetVisibilityLabel = ({ visibility, code, allowManage }) => (
  <Label
    className="aridhia-dataset-visibility-label"
    as={allowManage ? 'a' : undefined}
    href={allowManage ? datasetAdminUrl({ code }, '#') : undefined}
  >
    <Icon name={visibilityIcon[visibility]} />
    <FormattedMessage id={`visibility.${visibility}`} />
  </Label>
);

export default DatasetVisibilityLabel;
